import PartDipDetails from "./forms/PartDipDetails";
import PartWaxDetails from "./forms/PartWaxDetails";
import PartFoundry from "./forms/PartFoundry";
import PartPostFoundry from "./forms/PartPostFoundry";
import PartAssembly from "./forms/PartAssembly";
import PartAutoclave from "./forms/PartAutoclave";
import PartShipping from "./forms/PartShipping";
import PartThirdParty from "./forms/PartThirdParty";

export const SECTION_FORMS = {
  1: PartWaxDetails,
  12: PartAssembly,
  2: PartDipDetails,
  3: PartAutoclave,
  4: PartFoundry,
  5: PartPostFoundry,
  6: PartThirdParty,
  8: PartShipping,
};

export const PART_SECTIONS = {
  thirdParty: <PartThirdParty />,
  wax: <PartWaxDetails />,
  assembly: <PartAssembly />,
  dip: <PartDipDetails />,
  autoclave: <PartAutoclave />,
  foundry: <PartFoundry />,
  post: <PartPostFoundry />,
  shipping: <PartShipping />,
};

export const getFieldLabel = (label = "") =>
  label
    ?.split(".")
    .map((word) => `${word[0].toUpperCase()}${word?.slice(1)}`)
    .join("")
    .replace(/([a-z](?=[A-Z]))/g, "$1 ")
    .replace(/\[(\d+)\]/g, (_, n) => ` #${+n + 1} `)
    .replace("Number", "#")
    .replace("Id", "")
    .replace("Post Routes", "Finishing")
    .replace("Autoclave", "Dewax");
